import React, { useState, useEffect } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { HiMenuAlt3, HiX, HiChevronDown } from 'react-icons/hi';
import logo from '../assets/logo.png';

const NAV = [
  { label: 'Home',       to: '/' },
  { label: 'About',      to: '/about' },
  {
    label: 'Services', dropdown: [
      { label: 'EMS Solutions',    to: '/ems-solutions' },
      { label: 'Manufacturing',    to: '/manufacturing' },
    ],
  },
  { label: 'Industries', to: '/industries' },
  { label: 'Projects',   to: '/projects' },
  { label: 'Contact',    to: '/contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobile, setMobile] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const [mobSvc, setMobSvc] = useState(false);
  const [closeTimeout, setCloseTimeout] = useState(null);
  const loc = useLocation();

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  useEffect(() => {
    setMobile(false);
    setDropdown(false);
    setMobSvc(false);
  }, [loc]);

  const lnk = (active) => ({
    fontFamily: 'Inter',
    fontSize: 15,
    fontWeight: 500,
    color: active ? '#3d8b3d' : '#4a5568',
    textDecoration: 'none',
    padding: '9px 14px',
    borderRadius: 7,
    background: active ? '#eaf6ea' : 'transparent',
    transition: 'all .18s',
  });

  const handleMouseEnter = () => {
    if (closeTimeout) clearTimeout(closeTimeout);
    setDropdown(true);
  };

  const handleMouseLeave = () => {
    const timeout = setTimeout(() => setDropdown(false), 180);
    setCloseTimeout(timeout);
  };

  return (
    <nav style={{
      position: 'fixed',
      top: 0, left: 0, right: 0,
      zIndex: 1000,
      background: 'rgba(255,255,255,0.98)',
      borderBottom: '1px solid #e2e8f0',
      boxShadow: scrolled ? '0 2px 24px rgba(0,0,0,0.09)' : 'none',
      backdropFilter: 'blur(10px)',
      transition: 'box-shadow .3s',
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: 72,
        width: '100%',
        padding: '0 40px',
        boxSizing: 'border-box',
      }}>

        {/* Logo */}
        <Link to="/" style={{
          display: 'block',
          textDecoration: 'none',
          flexShrink: 0,
          width: 220,
          height: 56,
          overflow: 'hidden',
          position: 'relative',
        }}>
          <img
            src={logo}
            alt="Saalfo Tech"
            style={{
              height: 130,
              width: 'auto',
              position: 'absolute',
              top: -34,
              left: -14,
            }}
          />
        </Link>

        {/* Desktop Navigation */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }} className="d-nav">
          {NAV.map((n) =>
            n.dropdown ? (
              <div
                key="svc"
                style={{ position: 'relative' }}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                <button style={{
                  ...lnk(false),
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 5,
                }}>
                  {n.label}
                  <HiChevronDown
                    size={14}
                    style={{
                      transition: 'transform .2s',
                      transform: dropdown ? 'rotate(180deg)' : 'none',
                    }}
                  />
                </button>

                {dropdown && (
                  <div
                    style={{
                      position: 'absolute',
                      top: 'calc(100% - 2px)',
                      left: 0,
                      minWidth: 230,
                      background: '#fff',
                      border: '1px solid #e2e8f0',
                      borderRadius: 10,
                      boxShadow: '0 8px 30px rgba(0,0,0,0.1)',
                      padding: '12px 8px',
                      zIndex: 1000,
                    }}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                  >
                    {n.dropdown.map((d) => (
                      <NavLink
                        key={d.to}
                        to={d.to}
                        style={({ isActive }) => ({
                          display: 'flex',
                          alignItems: 'center',
                          gap: 8,
                          padding: '11px 16px',
                          borderRadius: 8,
                          fontSize: 14,
                          fontWeight: 500,
                          color: isActive ? '#3d8b3d' : '#374151',
                          background: isActive ? '#eaf6ea' : 'transparent',
                          textDecoration: 'none',
                          transition: 'background .15s',
                        })}
                        onMouseEnter={(e) => { e.currentTarget.style.background = '#f0faf0'; }}
                        onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
                      >
                        <span style={{
                          width: 5, height: 5,
                          borderRadius: '50%',
                          background: '#5cb85c',
                          flexShrink: 0,
                        }} />
                        {d.label}
                      </NavLink>
                    ))}
                  </div>
                )}
              </div>
            ) : (
              <NavLink key={n.to} to={n.to} style={({ isActive }) => lnk(isActive)}>
                {n.label}
              </NavLink>
            )
          )}

          <Link
            to="/contact"
            className="btn btn-primary"
            style={{ marginLeft: 14, fontSize: 14, padding: '10px 24px' }}
          >
            Get a Quote
          </Link>
        </div>

        {/* Mobile toggle */}
        <button
          onClick={() => setMobile(!mobile)}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            color: '#4a5568',
            display: 'none',
          }}
          className="m-tog"
        >
          {mobile ? <HiX size={26} /> : <HiMenuAlt3 size={26} />}
        </button>
      </div>

      {/* Mobile menu */}
      {mobile && (
        <div style={{
          borderTop: '1px solid #e2e8f0',
          background: '#fff',
          padding: '12px 24px 24px',
        }}>
          {NAV.map((n) =>
            n.dropdown ? (
              <div key="svc-m">
                <button
                  onClick={() => setMobSvc(!mobSvc)}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    width: '100%',
                    padding: '13px 0',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: 15,
                    fontWeight: 500,
                    color: '#374151',
                    borderBottom: '1px solid #f1f5f9',
                  }}
                >
                  Services
                  <HiChevronDown
                    size={15}
                    style={{
                      transform: mobSvc ? 'rotate(180deg)' : 'none',
                      transition: 'transform .2s',
                    }}
                  />
                </button>
                {mobSvc && (
                  <div style={{ paddingLeft: 16, paddingBottom: 8 }}>
                    {n.dropdown.map((d) => (
                      <NavLink
                        key={d.to}
                        to={d.to}
                        style={{
                          display: 'block',
                          padding: '10px 0',
                          fontSize: 14,
                          color: '#4a5568',
                          textDecoration: 'none',
                        }}
                      >
                        › {d.label}
                      </NavLink>
                    ))}
                  </div>
                )}
              </div>
            ) : (
              <NavLink
                key={n.to}
                to={n.to}
                style={({ isActive }) => ({
                  display: 'block',
                  padding: '13px 0',
                  fontSize: 15,
                  fontWeight: 500,
                  color: isActive ? '#3d8b3d' : '#374151',
                  textDecoration: 'none',
                  borderBottom: '1px solid #f1f5f9',
                })}
              >
                {n.label}
              </NavLink>
            )
          )}
          <Link
            to="/contact"
            className="btn btn-primary"
            style={{ marginTop: 18, width: '100%', justifyContent: 'center', fontSize: 15 }}
          >
            Get a Quote
          </Link>
        </div>
      )}

      <style>{`
        @media (max-width: 768px) {
          .d-nav { display: none !important; }
          .m-tog { display: block !important; }
        }
      `}</style>
    </nav>
  );
}